import * as React from 'react'

import { cn } from '../../lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-border bg-bg-elev text-fg w-full min-w-0 resize-y rounded-md border px-2.5 py-2 text-base transition-colors duration-100 ease-out outline-none',
        'placeholder:text-fg-subtle',
        'focus-visible:outline-accent focus-visible:outline-2 focus-visible:outline-offset-1',
        'disabled:pointer-events-none disabled:opacity-50',
        'aria-invalid:border-err aria-invalid:focus-visible:outline-err',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
